import { MNSproCloudApi } from '..';
import { ClassServicesResponseExtended, HomeworkResponse } from '../api/v2';

const getApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

  return api;
};

const getCourseApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  const api = MNSproCloudApi.V2.CoursesApiFactory(config);

  return api;
};

export class CoursesService {
  static async getCourseHomework(
    authToken: string,
    organizationId: string,
    courseId: string,
  ): Promise<HomeworkResponse[]> {
    const api = getApi(authToken);
    const response = await api.getMyHomeworkByCourse(courseId);

    return response.data;
  }

  static async getMyHomework(
    authToken: string,
    organizationId: string,
    onlyClassbook?: boolean,
  ): Promise<HomeworkResponse[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);
    const response = await api.getMyHomework(
      organizationId,
      undefined,
      onlyClassbook,
    );
    return response.data;
  }

  static async getMyServices(
    authToken: string,
    organizationId: string,
  ): Promise<ClassServicesResponseExtended[]> {
    const api = getApi(authToken);
    const response = await api.getMyClassServices(organizationId);

    return response.data;
  }

  static async getServicesOfCourse(
    authToken: string,
    organizationId: string,
    courseId: string,
  ): Promise<ClassServicesResponseExtended[]> {
    const api = getApi(authToken);
    const response = await api.getClassServicesOfGroup(
      courseId,
      organizationId,
    );

    return response.data;
  }

  static async repairTeamOwnerships(
    authToken: string,
    organizationId: string,
    courseId: string,
  ): Promise<void> {
    const api = getCourseApi(authToken);
    await api.repairTeamOwnerShip(organizationId, courseId);
  }
}
